import { useGlobalContext } from '../context'
import BabyWerewolf from './BabyWerewolf'
import DarkMatter from './DarkMatter'
import DeadFucker from './DeadFucker'
import Doctor from './Doctor'
import Dracula from './Dracula'
import FoolVampire from './FoolVampire'
import Vampire from './Vampire'
import Villager from './Villager'
import Warrior from './Warrior'
import Werewolf from './Werewolf'
import VotingScreen from './VotingScreen'
import VoteFinishScreen from './VoteFinishScreen'
import WaitingScreen from './WaitingScreen'



function Game() {
    const { players, index, votingScreen, voteFinishScreen, waitingScreen, blood } = useGlobalContext();
    //Show the current player
    let currentPlayer = players[index];
    //Screen after votes are completed
    if (voteFinishScreen) 
        return(<VoteFinishScreen></VoteFinishScreen>)
        
    //Voting screen
    else if (votingScreen)
        return (<VotingScreen></VotingScreen>)
        
    //Screen between the players turns
    else if (waitingScreen)
        return (<WaitingScreen></WaitingScreen>)
        
    //Screen if player is a vampire
    else if (currentPlayer.class === 'vampire')
        return (<Vampire></Vampire>)
    
    //Screen if player is a villager
    else if (currentPlayer.class === 'villager')
        return (<Villager></Villager>)
    
    //Screen if player is a deadfucker
    else if (currentPlayer.class === 'deadfucker')
        return (<DeadFucker></DeadFucker>)
    
    //Screen if player is a doctor
    else if (currentPlayer.class === 'doctor')
        return (<Doctor></Doctor>)
    
    //Screen if player is vitaminless vampire
    else if (currentPlayer.class === 'foolvampire')
        return (<FoolVampire></FoolVampire>)
    
    //Screen if player is werewolf
    else if (currentPlayer.class === 'werewolf')
        return (<Werewolf></Werewolf>)
    
    //Screen if player is baby werewolf
    else if (currentPlayer.class === 'babywerewolf')
        return (<BabyWerewolf></BabyWerewolf>)
    
    //Screen if player is dark matter
    else if (currentPlayer.class === 'darkmatter')
        return (<DarkMatter></DarkMatter>)

    //Screen if player is warrior
    else if (currentPlayer.class === 'warrior')
        return (<Warrior></Warrior>)
    
    //Screen if player is dracula
    else if (currentPlayer.class === 'dracula')
        return (<Dracula></Dracula>)
}

export default Game;